import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-llc-sync-header',
	templateUrl: './sync-header.component.html',
	styleUrls: ['./sync-header.component.scss'],
	standalone: false,
})
export class SyncHeaderComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
